<!-- Folded, this stays a 72px rail: hovering shows an item's card (or label) beside it, never the whole menu -->
<div [class.collapsed]="collapsed" class="vex-sidenav flex flex-col">
  <div class="vex-sidenav-toolbar__container">
    <!-- Logo + collapse button -->
    <div class="sidenav-header">
      <!--<img *ngIf="!collapsed" src="assets/img/logo/tan-logo.png" alt="TAN" class="sidenav-logo" />-->
      <img *ngIf="brandingService.sidenavLogo" [src]="brandingService.sidenavLogo" [alt]="brandingService.brandName" class="sidenav-logo" />
      <span *ngIf="!brandingService.sidenavLogo" class="sidenav-logo sidenav-logo-placeholder"
            [style.background]="brandingService.placeholderColor" [title]="brandingService.brandName">
        {{ brandingService.brandInitial }}
      </span>
      
      <!-- The only way to fold or unfold; the rail shows it turned around -->
      <button (click)="toggleCollapse()" class="sidenav-collapse-btn" mat-icon-button type="button"
        [attr.aria-label]="collapsed ? 'Expand menu' : 'Collapse menu'"
        [matTooltip]="collapsed ? 'Expand menu' : ''" matTooltipPosition="right">
        <i class="tan-icon-d g-ic-close-panel bg-white/60" [class.rotate-180]="collapsed"></i>
      </button>
    </div>

    <div *ngIf="!collapsed" class="sidenav-search-bar">
      <i class="tan-icon-d g-ic-search bg-white/60"></i>
      <input
        #searchInput
        type="text"
        class="sidenav-search-input"
        placeholder="Search..."
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearch($event)"
      />
    </div>
    
    <!-- The rail has no room for the box: its search icon unfolds the menu and focuses the box -->
    <button *ngIf="collapsed" (click)="openSearch()" class="sidenav-search-rail" type="button"
      aria-label="Search the menu" matTooltip="Search" matTooltipPosition="right">
      <i class="tan-icon-d g-ic-search bg-white/60"></i>
    </button>
  </div>

  <vex-scrollbar class="flex-1 flex flex-col overflow-x-hidden">
    <!-- Abel 1/10/24: Añado el botón aquí -->
    <div class="pt-6 flex-1">
      <ng-container *ngIf="filteredItems$ | async as list">
        <vex-sidenav-item *ngFor="let item of list; trackBy: trackByRoute" [item]="item"
          [level]="0"></vex-sidenav-item>
        <!-- A search that left nothing (the mockup's words) -->
        <div *ngIf="!list.length && searchQuery.trim()" class="vex-sidenav-empty">Nothing matches.</div>
      </ng-container>
    </div>

    <div class="vex-sidenav-footer flex items-center justify-center opacity-20 px-6 py-6 select-none flex-none">
      <img src="assets/img/logo/tan.png" alt="Logo" class="w-8 select-none" />
      <label class="label-margin-left">v. {{version}}</label>
    </div>
  </vex-scrollbar>

  <div class="vex-sidenav-user__container flex-none">
    <!-- The account menu opens like the item cards: on hover (short delay), click or Enter/Space -->
    <div #userProfileMenuOriginRef cdkOverlayOrigin #userOrigin="cdkOverlayOrigin"
      (click)="openUserMenu()" (mouseenter)="onUserEnter()" (mouseleave)="onUserLeave()"
      (keydown.enter)="onProfileKey($event)" (keydown.space)="onProfileKey($event)"
      (keydown.escape)="closeUserMenu()"
      tabindex="0" role="button" aria-haspopup="menu" [attr.aria-expanded]="userMenuOpen"
      [class.vex-sidenav-user--open]="userMenuOpen" class="vex-sidenav-user flex items-center" matRipple
      matRippleColor="var(--vex-sidenav-item-ripple-color)">
      <img alt="User Avatar" class="vex-sidenav-user__image flex-none"
        src="{{ securityService.securityObject.userPhoto }}" />
      <div class="vex-sidenav-user__content flex-auto">
        <div class="vex-sidenav-user__title">{{ securityService.securityObject.userFirstName }} {{
          securityService.securityObject.userLastName }}</div>
        <!-- Organization, then the person's role in it ("Accent Network, LLC · Admin") -->
        <div class="vex-sidenav-user__subtitle">{{ securityService.securityObject.orgName }}<span
          class="vex-sidenav-user__role"> · {{ roleLabel }}</span></div>
      </div>
      <mat-icon class="vex-sidenav-user__dropdown-icon flex-none" svgIcon="mat:arrow_drop_down"></mat-icon>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="userOrigin" [cdkConnectedOverlayOpen]="userMenuOpen"
      [cdkConnectedOverlayPositions]="userMenuPositions" [cdkConnectedOverlayWidth]="userMenuWidth"
      [cdkConnectedOverlayPush]="true" (overlayOutsideClick)="onUserMenuOutsideClick($event)"
      (overlayKeydown)="onUserMenuKey($event)" (detach)="closeUserMenu()">
      <vex-sidenav-user-menu (closed)="closeUserMenu()" (mouseenter)="onUserMenuEnter()"
        (mouseleave)="onUserLeave()"></vex-sidenav-user-menu>
    </ng-template>
  </div>
</div>